import '@contentful/live-preview/style.css';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { TealiumProvider } from '@nib/tealium-universal-tag/react';
import { tealiumConfig } from './constants';

const { account, profile, environment } = tealiumConfig;

export const wrapRootElement = ({ element }) => (
  <TealiumProvider account={account} profile={profile} environment={environment}>
    {element}
  </TealiumProvider>
);
